import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`It's a breaking workflow when I need to take a picture of screen (to clipboard), save it into somewhere and link it before starting to write something in markdown. This plugin is to fix that for vim users. It can also do the same job for image file if you have its absolute path in clipboard!`}</p>
    <h1>{`But Markdown Cannot Show Image!`}</h1>
    <p>{`Well I don't want to address this problem here but technically yes it can if you use a fancier terminal like `}<a parentName="p" {...{
        "href": "https://www.iterm2.com/"
      }}>{`iTerm2`}</a>{`. Actually for markdown preview in vim, a practical way is to use GUI vim e.g. `}<a parentName="p" {...{
        "href": "https://github.com/qvacua/vimr"
      }}>{`vimR`}</a>{` or browser solution like `}<a parentName="p" {...{
        "href": "https://github.com/suan/vim-instant-markdown"
      }}>{`markdown instant preview`}</a>{`. However, if you are hardcore vimmer, probably solution as in `}<a parentName="p" {...{
        "href": "https://github.com/ashisha/image.vim"
      }}>{`image.vim`}</a>{` will be preferrable. Maybe at some point, we could write another plugin to display colorful blocky image in markdown vim.`}</p>
    <h1>{`Search in Darkness`}</h1>
    <p>{`First we need to grab clipboard data and this is not trivial at all in Python. `}<a parentName="p" {...{
        "href": "https://stackoverflow.com/questions/7045264/how-do-i-read-a-jpg-or-png-from-the-windows-clipboard-in-python-and-vice-versa"
      }}>{`This`}</a>{` one from `}<a parentName="p" {...{
        "href": "https://python-pillow.org/"
      }}>{`PIL`}</a>{` actually only support win32 unfortunately. So I did some research on stackoverflow: went through recommendations like `}<a parentName="p" {...{
        "href": "https://pypi.python.org/pypi/pyperclip"
      }}>{`Pyperclip`}</a>{` (text-only and I used before but got issues due to its GUI dependencies in `}<a parentName="p" {...{
        "href": "https://github.com/ranger/ranger"
      }}>{`Ranger`}</a>{`), `}<a parentName="p" {...{
        "href": "https://wiki.python.org/moin/TkInter"
      }}>{`TKinter`}</a>{` (too heavy for a vim plugin), `}<a parentName="p" {...{
        "href": "https://stackoverflow.com/questions/7045264/how-do-i-read-a-jpg-or-png-from-the-windows-clipboard-in-python-and-vice-versa#answer-7047190"
      }}>{`PythonMagick`}</a>{` (I use `}<a parentName="p" {...{
        "href": "https://www.imagemagick.org/script/index.php"
      }}>{`Magick`}</a>{` a lot, but this python version has no `}<a parentName="p" {...{
        "href": "http://pip.pypa.io/en/stable/"
      }}>{`pip`}</a>{` support, and is hard to install for normal users), `}<a parentName="p" {...{
        "href": "https://stackoverflow.com/questions/7083313/python-get-mac-clipboard-contents#answer-8309779"
      }}>{`Xerox`}</a>{` (only support text, `}<a parentName="p" {...{
        "href": "https://pypi.python.org/pypi/richxerox/1.0.0"
      }}>{`richxerox`}</a>{` does extra for html but didn't support image)... I'm surprised that we don't have this in Python! Maybe because this type (clipboard) of GUI related feature have too much trap to cross platform. But I just need it work on Mac OSX and Linux.`}</p>
    <h1>{`From Scratch`}</h1>
    <p>{`Therefore, here's what I could do at this point:
For Mac OS X: we just need to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`brew install pngpaste`}</code>{` from `}<a parentName="p" {...{
        "href": "https://github.com/jcsalterego/pngpaste"
      }}>{`here`}</a>{`. Then use osascript to check the clipboard information and call this program to do the job.
For Linux: this `}<a parentName="p" {...{
        "href": "https://stackoverflow.com/questions/6841532/linux-image-from-clipboard#answer-27995840"
      }}>{`answer`}</a>{` looks promising.`}</p>
    <p>{`Ok, let's quickly build a working plugin. Since we have access to clipboard and we could also check if clipboard contains image file name to copy it to local folder and link in markdown as well.`}</p>
    <p>{`Hooray for Mac Vim user! Now, let's make it work in Linux.`}</p>
    <h1>{`Bumping Around`}</h1>
    <p>{`Again promising `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`xclip`}</code>{` suggested from `}<a parentName="p" {...{
        "href": "https://stackoverflow.com/questions/6841532/linux-image-from-clipboard#answer-27995840"
      }}>{`here`}</a>{` doesn't work... and some suggests `}<a parentName="p" {...{
        "href": "https://superuser.com/questions/199285/how-to-copy-image-to-clipboard-to-paste-to-another-application/247069#answer-247069"
      }}>{`pygtk`}</a>{`. Okay, looks like we are stuck in GTK but that should be fine (easier to install on linux and probably on mac as well) for most use cases. PyGtk is actually a bit old, and we'd better use GTK3 from `}<a parentName="p" {...{
        "href": "https://python-gtk-3-tutorial.readthedocs.io/en/latest/index.html"
      }}>{`here`}</a>{`.`}</p>
    <p>{`So I installed `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`pyobject2`}</code>{` and `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`python34-gobject`}</code>{` and try the `}<a parentName="p" {...{
        "href": "https://pygobject.readthedocs.io/en/latest/"
      }}>{`test code`}</a>{`. After making sure everything works, just follow the `}<a parentName="p" {...{
        "href": "http://python-gtk-3-tutorial.readthedocs.io/en/latest/clipboard.html"
      }}>{`example`}</a>{` snippet:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "python"
    }}><pre parentName="div" {...{
        "className": "language-python"
      }}><code parentName="pre" {...{
          "className": "language-python"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` gi
gi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`require_version`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'Gtk'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'3.0'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` gi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`repository `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` Gtk`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` Gdk

clipboard `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` Gtk`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`Clipboard`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`get`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`Gdk`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`SELECTION_CLIPBOARD`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
image `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` clipboard`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`wait_for_image`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` image `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`is`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`not`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`None`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
    image`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`savev`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'screenshot.png'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'png'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

text `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` clipboard`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`wait_for_text`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` text `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`is`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`not`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`None`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`print`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`text`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <p>{`It's so simple, neat and I just wanted to have it on Mac as well.`}</p>
    <h1>{`Revisit PyGObject on Mac`}</h1>
    <p>{`conda install -c conda-forge pygobject`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      